import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { createClient } from '@sanity/client';
import BlockContent from '@sanity/block-content-to-react';

import Nav from '../components/Nav.jsx';
import Footer from '../components/Footer.jsx';

const client = createClient({
  projectId: 'g26kqswn',
  dataset: 'production',
  apiVersion: '2024-01-23',
  useCdn: false,
});

const serializers = {
  types: {
    block: (props) => {
      const { style = 'normal' } = props.node;
      if (/^h\d/.test(style)) {
        const level = style.replace('h', '');
        return React.createElement(
          style,
          { className: `text-${4 - level}xl font-bold my-4` },
          props.children
        );
      }
      if (style === 'blockquote') {
        return <blockquote className="border-l-4 border-gray-300 pl-4 italic my-4">{props.children}</blockquote>;
      }
      return <p className="mb-4 text-lg">{props.children}</p>;
    },
  },
};

export default function Post() {
  const [postData, setPostData] = useState(null);
  const { slug } = useParams();

  useEffect(() => {
    const query = `*[_type == "post" && slug.current == $slug][0]{
      title,
      _id,
      slug,
      publishedAt,
      "previewImage": previewImage.asset->url,
      "authorName": author->name,
      "authorImage": author->image.asset->url,
      body
    }`;

    client.fetch(query, { slug })
      .then((data) => setPostData(data))
      .catch(console.error);
  }, [slug]);

  if (!postData) return <div>Loading...</div>;

  return (
    <>
      <Nav />
      <div className="bg-white px-6 py-32 lg:px-8">
        <div className="mx-auto max-w-3xl text-base leading-7 text-gray-700">
          <p className="text-base font-semibold leading-7 text-indigo-600">
            {new Date(postData.publishedAt).toLocaleDateString()}
          </p>
          <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            {postData.title}
          </h1>
          
          {postData.previewImage && (
            <img 
              src={postData.previewImage} 
              alt={postData.title}
              className="mt-8 rounded-2xl bg-gray-50 object-cover w-full"
            />
          )}

          <div className="mt-10 max-w-2xl">
              <BlockContent blocks={postData.body} serializers={serializers} projectId={client.config().projectId} dataset={client.config().dataset} />
          </div>
          
          {postData.authorName && (
             <div className="mt-12 flex items-center gap-x-4">
                {postData.authorImage && <img src={postData.authorImage} alt={postData.authorName} className="h-10 w-10 rounded-full bg-gray-100" />}
                <div className="text-sm leading-6">
                    <p className="font-semibold text-gray-900">{postData.authorName}</p>
                </div>
            </div>
          )}

        </div>
      </div>
      <Footer />
    </>
  );
} 